<h1 class="page-title">Online Credential Verification Preference</h1>
<form *ngIf="!submitted" [formGroup]="profileForm" (ngSubmit)="onSubmit(profileForm.value)">
	<div class="field-message-section">
		<div class="field">
			<div class="field__label-input-wrap">
				<label for="email" class="label">Email</label>
				{{email}}
				<div *ngIf="formErrors.email" class="error-message field__error-message">{{ formErrors.email }}</div>
			</div>
		</div>
		<p>Yes, I want to opt in for online verification of my credentials.</p>
<!-- 		<div class="form-row">			
			<div class="field field--inline">
				<input class="input input--checkbox" id="directoryOptOut" formControlName="directoryOptOut" type="checkbox" (change)="isOptOut($event)">
				<label for="directoryOptOut" class="label label--inline">I wish to exclude my name from the online verify credential search.</label>
			</div>
		</div>
		<div *ngIf="!validFormCheck"  class="error-message">
			<div class="form-row">
				<p>Fix errors indicated above to continue.</p>
			</div>	
		</div> -->
	</div>
	<div class="form-actions">
 		<input class="button form-actions__item" type="submit" value="Submit" /> 
<!-- 		<button (click)="cancel($event)" class="button button--secondary form-actions__item">Cancel</button> -->
	</div>
</form>
<div *ngIf="submitted">
	Your preference has been updated. You can always login at <a href="practitionerportal.nbrc.org">nbrc.org</a> to update your preferences.
</div>